import TableHeadings from '../../../components/Common-components/table-headings'
import { Spinner } from '../../../components/Common-components/spinner'
import { useFinancialReport } from '../hook/useFinancialReport'
import { Pagination } from '../../../components/Pagination'
import { useTranslation } from 'react-i18next'
import { FinancialReportFilters } from '../component/financialReportFilters'
import moment from 'moment-timezone'

export const ReleasePayment = () => {
    const { t } = useTranslation()
    const { data, methods } = useFinancialReport()
    const { paymentReleaseTableHead, details, loader, controller, totalCount } = data
    const { handlePagination } = methods
    return (
        <>
            {loader && <Spinner />}
            <section className="filter">
                <FinancialReportFilters data={data} methods={methods} />
            </section>{' '}
            <div className="table-responsive custom_table px-2 flex-fill mt-3 custom_scroll">
                <table className="table cus-table mt-3">
                    <TableHeadings removeTr={true} TableHeadData={paymentReleaseTableHead} />
                    <tbody>
                        {details?.length ? (
                            details?.map((row, index) => (
                                <tr className="fw-4 font-12" key={row?._id}>
                                    <td align="center">{controller?.rowsPerPage * (controller?.page - 1) + index + 1}</td>
                                    <td align="center">{row?.vendorName || '- -'}</td>
                                    <td align="center">{row?.amount || '- -'}</td>
                                    <td align="center">{row?.bookingReferenceNumber || '- -'}</td>
                                    <td align="center">{moment(row?.createdAt).format('lll') || '- -'}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={12} align="center">
                                    {t('tableTitle.noRecordFound')}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            {totalCount > 10 && (
                <div>
                    <Pagination count={totalCount} controller={controller} setController={handlePagination} />
                </div>
            )}
        </>
    )
}
